import { liveUsageMgmtSliceSelector } from "./liveUsageMgmtSliceSelector";
import { RootState } from "@/store/store";
import { ProviderType } from "@/services/cloudchipr.api";

export const liveUsageMgmtProviderSelector = (
  state: RootState,
): ProviderType | null => liveUsageMgmtSliceSelector(state).provider;
